module.exports = __webpack_public_path__ + "img/loudspeaker.15cc646c.png";